import React, {
  FunctionComponent as FC,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux'; // To call Action Creators
import { State } from '../../../../state';
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../state";
import * as d3 from 'd3';
import _ from 'lodash';
import './index.scss';

import { forceSimulation } from 'd3-force';

import GlyphGroup from './GlyphGroup';

import { MainViewTypes } from '../../../../types/data.d';
import { CitationFlowType } from '../../../../types/data.global';


interface GrantTypeNodeProps {
  glyphDataAll: any[];
  entityFieldGraphData: any;
  predictionData: MainViewTypes.PredictionResult;
}

const GrantTypeNode: FC<GrantTypeNodeProps> = (props) => {

  const {
    glyphDataAll,
    entityFieldGraphData,
    predictionData,
  } = props;

  const dispatch = useDispatch()
  const {
    updateGrantFieldNodePosition,
    setShowEntityFieldLevelGraph,
    setShowEntityTypeLevelGraph,
    isShowHistoricalFlow,
    isShowPredictionFlow,
  } = bindActionCreators(actionCreators, dispatch)


  // console.log('\n\n\n=========== [Step 2] GrantTypeNode component (draw after EntityTypeLevelGraph) =============')
  // console.log('glyphDataAll: ', glyphDataAll)
  // console.log('predictionData: ', predictionData)


  // data reducer
  const entityTypeLayoutData: any = useSelector((state: State) => state.dataReducer?.entityTypeLayoutData) as any
  const predictionSearchResult: MainViewTypes.PredictionSearchResult = useSelector((state: State) => state.dataReducer?.predictionSearchResult) as MainViewTypes.PredictionSearchResult
  // const updatedEntityFieldData = _.cloneDeep(entityFieldGraph_InputData)
  const updatedEntityFieldDataRaw: any[] = useSelector((state: State) => state.dataReducer?.entityFieldGraph_InputData) as any[]
  const updatedEntityFieldData = _.cloneDeep(updatedEntityFieldDataRaw)

  // ui reducer
  const glyphStyle = useSelector((state: State) => state.uiReducer?.glyphStyle) as MainViewTypes.GlyphStyle
  const grantTypeNodeTransformXY = useSelector((state: State) => state.uiReducer?.grantTypeNodeTransformXY) as { x: number, y: number }
  const svgSize = useSelector((state: State) => state.uiReducer?.svgSize) as { width: number, height: number }
  const showEntityTypeLevelGraph: boolean = useSelector((state: State) => state.uiReducer?.showEntityTypeLevelGraph) as boolean
  const isEntityTypeGraphFinished: boolean = useSelector((state: State) => state.dataReducer?.isEntityTypeGraphFinished) as boolean
  const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string
  const citationFlowType: string = useSelector((state: State) => state.uiReducer?.citationFlowType) as string
  const impactStatisticsTypeList: string[] = useSelector((state: State) => state.uiReducer?.impactStatisticsTypeList) as string[]
  const topKNodes: number = useSelector((state: State) => state.uiReducer?.topKField) as number
  const glyphType: string = useSelector((state: State) => state.uiReducer?.grantGlyphType) as string

  // filter topK grant field nodes: filter glyphDataAll (already ranked by funding_usd from backend)
  const glyphData = glyphDataAll.slice(0, topKNodes)
  // console.log('glyphData (topKNodes): ', glyphData.map(d => d.grant_field_code))
  // get `impactTypeRefined` for following use
  const parts = impactType.split("_")
  const impactTypeRefined = parts.slice(0, 2).join("_")


  // get grant type node position
  const grantTypeNodeData = entityTypeLayoutData['nodes'].find((node: MainViewTypes.EntityTypeNode) => node.id === 'grant')
  const grantTypeNodeX = grantTypeNodeData?.x || 0
  const grantTypeNodeY = grantTypeNodeData?.y || 0


  // console.log('updatedEntityFieldDataRaw: ', updatedEntityFieldDataRaw)
  // console.log('updatedEntityFieldData: ', updatedEntityFieldData)
  // console.log('grantTypeNodeX: ', grantTypeNodeX)
  // console.log('grantTypeNodeY: ', grantTypeNodeY)


  // ////////////////////   Prediction Result  /////////////////////
  // // input
  // // 1. UI parameters
  // console.log('citationFlowType: ', citationFlowType)
  // console.log('impactTypeRefined: ', impactTypeRefined)
  // // // 2. temp, hard code, to replace with backend prediction result
  // // const predictionResult: MainViewTypes.PredictionResult = predictionResultTest[impactTypeRefined]
  // // // 3. temp, hard code, to replace with Xiaoyu右下角view的搜索结果
  // // const predictionSearchResult = {
  // //   // impactType: ImpactType.INDIRECT_IMPACT_FOLDED, --> already store in state `impactType`
  // //   entity: 'clinical_trial',
  // //   fieldIDList: ['C11.768', 'C23.888'],
  // // }
  // console.log('predictionSearchResult: ', predictionSearchResult)

  // filter prediction result
  // opt 1: use topK fieldIDs
  let predictionResult_SearchTerm: any[] = []
  if ((predictionSearchResult.entity === '') || (predictionSearchResult.fieldIDList.length === 0)) {
    // pass
  } else {
    if (citationFlowType === CitationFlowType.PREDICTION) {
      console.log('predictionSearchResult.entity: ', predictionSearchResult.entity)
      if (predictionData[impactTypeRefined] && predictionData[impactTypeRefined][predictionSearchResult.entity]) {
        console.log('found!!')
        predictionResult_SearchTerm = predictionData[impactTypeRefined][predictionSearchResult.entity].filter((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => predictionSearchResult.fieldIDList.includes(fieldIDData.field_id))
        // // temp, hard code: 先pass direct impact (TODO: refine后端prediction结果处理)
        // if (impactTypeRefined === ImpactType.DIRECT_IMPACT) {
        //   // temp, hard code: 先pass direct impact (TODO: refine后端prediction结果处理)
        // } else {
        //   predictionResult_SearchTerm = predictionData[predictionSearchResult.entity].filter((fieldIDData: MainViewTypes.PredictionEntityFieldIDUnit) => predictionSearchResult.fieldIDList.includes(fieldIDData.field_id))
        // }
      } else {
        console.log('==> GrantTypeNode: predictionData[impactTypeRefined][predictionSearchResult.entity] is not found')
      }

    } else {
      // pass. Do nothing of historical flow
    }
  }
  // opt 2:
  // console.log('impactEntitySearchResult: ', impactEntitySearchResult)
  // note: 小钰现在搜索的是当前层的所有field_name。
  // TODO
  // console.log('predictionResult_SearchTerm: ', predictionResult_SearchTerm)
  // ////////////////////   Prediction Result  /////////////////////






  // 1. set global style parameters
  // 1-1. glyph size and r
  // console.log('svgSize: ', svgSize)
  const glyphParameterDict = {
    glyphR: glyphStyle.glyphMaxR, // temp, unified glyph size. TODO: scale the group with total_impact
    minR_Ratio: glyphStyle.minR_Ratio,
    RDifference_Ratio: glyphStyle.RDifference_Ratio,  // value范围在[minR_Ratio, minR_Ratio + RDifference_Ratio]之间
  }

  // 2. set scale
  // 2-1. scale-1: node layout: XY position
  // opt 1: dimension reduction
  const grantGlyphGroupR = glyphStyle.grantGlyphGroupR

  // 2-2.scale-2: glyph size scale
  const glyphSizeScaleAttr = 'funding_usd' // 'num_grant', 'funding_usd'
  const glyphRRangeRatio = glyphStyle.glyphRRangeRatio
  const glyph_SizeScale = d3.scaleSymlog() // scaleLinear, scaleSymlog
    .domain([Math.min(...glyphData.map(d => d[glyphSizeScaleAttr])), Math.max(...glyphData.map(d => d[glyphSizeScaleAttr]))])
    .range([glyphRRangeRatio.min, glyphRRangeRatio.max]);


  // 2-4. scale-4: axis in ImpactCount glyph
  const attrList_ImpactCountGlyph = {
    basicAttr: ['num_grant', 'funding_usd'],
    directImpact: ['num_paper', 'num_hit_paper', 'num_disruptive_paper', 'num_patent', 'num_clinical_trial'],
    indirectImpact: ['num_citing_patent', 'num_citing_clinical_trial', 'num_citing_policy', 'num_citing_newsfeed']
  }
  const ImpactCountGlyph_allAttributes = [...attrList_ImpactCountGlyph.basicAttr, ...attrList_ImpactCountGlyph.directImpact, ...attrList_ImpactCountGlyph.indirectImpact]
  const ImpactCountGlyphData = glyphData.map(item => {
    let newItem: any = {};
    ImpactCountGlyph_allAttributes.forEach(attr => {
      if (item.hasOwnProperty(attr)) {
        newItem[attr] = item[attr];
      }
    });
    return newItem;
  })


  // 3. draw glyph
  // 3-1. init node position using tsne x, y
  // temp: use impact count node position as initial position. 两种glyph mode用同一个初始化位置，这样切换glyph的时候，node位置、大小都不变，只改glyph -- keep context the same
  const glyphPositionXYScale = {
    x: d3.scaleLinear()
            .domain([Math.min(...ImpactCountGlyphData.map(d => d.tsne_x)), Math.max(...ImpactCountGlyphData.map(d => d.tsne_x))])
            .range([-(grantGlyphGroupR - glyphParameterDict.glyphR), (grantGlyphGroupR - glyphParameterDict.glyphR)]),
    y: d3.scaleLinear()
            .domain([Math.min(...ImpactCountGlyphData.map(d => d.tsne_y)), Math.max(...ImpactCountGlyphData.map(d => d.tsne_y))])
            .range([-(grantGlyphGroupR - glyphParameterDict.glyphR), (grantGlyphGroupR - glyphParameterDict.glyphR)])
  }
  const [circleData, setCircleData] = useState(glyphData.map(d => ({
    ...d,
    x: glyphPositionXYScale.x(d.tsne_x),
    y: glyphPositionXYScale.y(d.tsne_y),
    vx: 0, // 确保初始速度为0
    vy: 0, // 确保初始速度为0
  })))
  const centerX = 0
  const centerY = 0
  const maxRadius = grantGlyphGroupR
  const nodePadding = glyphStyle.nodePadding


  // console.log('circleData: ', circleData)


  // 3-2. adjust node position, aviod overlapping, with border constraint
  // temp: use impact count node position as initial position. 两种glyph mode用同一个初始化位置，这样切换glyph的时候，node位置、大小都不变，只改glyph -- keep context the same
  // const [isDrawGrantTypeNodeFinished, setIsDrawGrantTypeNodeFinished] = useState(false)
  useEffect(() => {
    if (isEntityTypeGraphFinished && updatedEntityFieldData) {
      // 1. get entityType node positions, based on `updatedEntityFieldData`
      const selectedEntityTypeNodePositionList = updatedEntityFieldData.filter((entityData) => impactStatisticsTypeList.includes(entityData.id)).map((entityData) => ({
        entity: entityData.id,
        x: entityData.x,
        y: entityData.y,
      }))

      // Declare attributeForce as a function expression
      // attributeForce(alpha: number): This function calculates a force for each node in circleData based on their attributes. The force is calculated as a vector from the node's position to the position of each "impact entity", scaled by a value (RCIValue). The resultant force is the sum of these vectors. This force is then applied to the node, moving it in the direction of the force.

      // 预计算entity positions，避免重复计算
      const entityPositions = selectedEntityTypeNodePositionList.map(entity => ({
        entity: entity.entity,
        x: entity.x - grantTypeNodeX,  // 从全局(以svg左上角(0,0)为原点)减去 grant group 的平移
        y: entity.y - grantTypeNodeY,
      }));

      // console.log('impactStatisticsTypeList: ', impactStatisticsTypeList)
      // console.log('isEntityTypeGraphFinished: ', isEntityTypeGraphFinished)
      // console.log('updatedEntityFieldData: ', updatedEntityFieldData)
      // console.log('selectedEntityTypeNodePositionList: ', selectedEntityTypeNodePositionList)
      // console.log('entityPositions: ', entityPositions)
      // console.log('circleData: ', circleData)


      // define three weigths for three types of force
      // === weights: 想要的视觉占比（任意数都可以，下面会归一化到和为1）===
      let W_ATTR  = 0.7;  // α：Impact/attributeForce 权重
      let W_CONT  = 0.2; // β：containForce 权重
      let W_COLL  = 0.1; // γ：collide 权重

      // 归一化，且保证非负
      W_ATTR = Math.max(0, W_ATTR);
      W_CONT = Math.max(0, W_CONT);
      W_COLL = Math.max(0, W_COLL);
      const W_SUM = (W_ATTR + W_CONT + W_COLL) || 1;
      const WA = W_ATTR / W_SUM;   // α
      const WB = W_CONT / W_SUM;   // β
      const WG = W_COLL / W_SUM;   // γ

      // force 1: Impact Force
      // opt 1: nhb-ftf-2025 version
      // force 1: Impact Force  —— 方案B：吸引 ~ dist；排斥 ~ 1/dist
      // 在 attributeForce 里，完全用“局部系”做向量计算(不是全局系的SVG左上角(0,0)的坐标，而是相对于grant group的(grantTypeNodeX, grantTypeNodeY)作为原点的坐标)：
      const attributeForce = (cool: number) => {
        const kBase = 0.02;                 // 你的原始基准
        const k = cool * kBase * WA;        // ★ 乘上 α

        // const k = alpha * 0.02;       // 基本强度（可调）
        const EPS = 1e-6;
        const FMAX = 2.0;             // 力限幅，防尖峰

        for (let i = 0; i < circleData.length; i++) {
          const node = circleData[i];

          // // 节点全局坐标（和 entityPositions 同一坐标系）
          // const nodeGX = node.x + grantTypeNodeX;
          // const nodeGY = node.y + grantTypeNodeY;

          let fx = 0, fy = 0;

          for (let j = 0; j < entityPositions.length; j++) {
            const entityPos = entityPositions[j];
            const impactEntity = entityPos.entity;

            // 取 RCI，缺省回退到 1（中性）
            let RCIValue = 1;
            if (impactTypeRefined === 'direct_impact') {
              RCIValue = (node[`RCI_num_${impactEntity}`] ?? 1);
            } else if (impactTypeRefined === 'indirect_impact') {
              RCIValue = (node[`RCI_num_citing_${impactEntity}`] ?? 1);
            }

            const s = RCIValue - 1;                    // >0 吸引，<0 排斥
            const dx = entityPos.x - node.x;            // **注意：全是局部坐标**
            const dy = entityPos.y - node.y;
            // const dx = entityPos.x - nodeGX;
            // const dy = entityPos.y - nodeGY;
            const distRaw = Math.hypot(dx, dy) || EPS; // 距离
            const ux = dx / distRaw;
            const uy = dy / distRaw;

            // 方案B核心：吸引随距离增大；排斥随距离衰减
            let mag = s >= 0 ? (k * s * distRaw)       // attract ~ dist
                            : (k * s / distRaw);      // repel   ~ 1/dist

            // 限幅，避免数值爆炸
            if (mag >  FMAX) mag =  FMAX;
            if (mag < -FMAX) mag = -FMAX;

            fx += mag * ux;
            fy += mag * uy;
          }

          // 只改速度，位置交给 d3 仿真积分
          node.vx += fx;
          node.vy += fy;
        }
      };
      // const attributeForce = (alpha: number) => {
      //   const forceStrength = alpha;
      //   // const forceStrength = alpha * 0.03; // 稍微提高force强度，确保有足够的初始运动

      //   for (let i = 0; i < circleData.length; i++) {
      //     const node = circleData[i]

      //     // 2. get glyph initial positions
      //     // 得到这个glyph相对于svg左上角(0,0)的坐标
      //     const nodePositionX: number = node.x + grantTypeNodeX
      //     const nodePositionY: number = node.y + grantTypeNodeY
      //     // const nodePositionX: number = node.x + grantTypeNodeTransformXY.x
      //     // const nodePositionY: number = node.y + grantTypeNodeTransformXY.y
      //     console.log('\n\nnode: ', node)
      //     console.log('(nodePositionX, nodePositionY): ', [nodePositionX, nodePositionY])
      //     console.log('grantTypeNodeTransformXY: ', grantTypeNodeTransformXY)


      //     // 3. calc vectors (with length representing RCI value) between this node/glyph and all impact entities
      //     let totalForceX = 0;
      //     let totalForceY = 0;

      //     for (let j = 0; j < entityPositions.length; j++) {
      //       const entityPos = entityPositions[j];
      //       const impactEntity = entityPos.entity;

      //       // get RCI value
      //       let RCIValue = 0
      //       if (impactTypeRefined === 'direct_impact') {
      //         RCIValue = node[`RCI_num_${impactEntity}`] || 0
      //       } else if (impactTypeRefined === 'indirect_impact') {
      //         RCIValue = node[`RCI_num_citing_${impactEntity}`] || 0
      //       }

      //       const dx = entityPos.x - nodePositionX;
      //       const dy = entityPos.y - nodePositionY;
      //       const raw = Math.hypot(dx, dy);
      //       const dist = Number.isFinite(raw) && raw > 0 ? raw : 1e-6;
      //       // const dist = Math.hypot(dx, dy) || 1e-6;  // 等价于 √(dx² + dy²)，但 hypot 在数值上更稳定（避免大数溢出/小数下溢，比自己写 Math.sqrt(dx*dx + dy*dy) 更稳）。用一个很小的备选值-- 1e-6 --做“兜底”
      //       const coeff = (RCIValue - 1) * forceStrength * dist; // ≈ 距离平方×单位方向
      //       totalForceX += coeff * dx;
      //       totalForceY += coeff * dy;

      //       // // 直接累加force，避免创建中间数组
      //       // const forceMultiplier = (RCIValue - 1) * forceStrength;
      //       // totalForceX += (entityPos.x - nodePositionX) * forceMultiplier;
      //       // totalForceY += (entityPos.y - nodePositionY) * forceMultiplier;
      //     }

      //     // Move the node towards the target
      //     node.vx += totalForceX;
      //     node.vy += totalForceY;
      //     // node.x += node.vx;
      //     // node.y += node.vy;

      //     // console.log('totalForceX: ', totalForceX)
      //     // console.log('totalForceY: ', totalForceY)
      //   }
      // }
      // // opt 2: vis2024 version
      // const attributeForce = (alpha: number) => {
      //   const forceStrength = alpha * 0.03; // 稍微提高force强度，确保有足够的初始运动

      //   for (let i = 0; i < circleData.length; i++) {
      //     const node = circleData[i]

      //     // // 注意：这里不要改 node.x/y，只改 vx/vy
      //     // let fx = 0, fy = 0;

      //     // 2. get glyph initial positions
      //     // 好像是相对坐标的问题：glyphTypeNode: cxcy中心是(0,0). 但是entityType node的cx，cy好像不是
      //     const nodePositionX: number = node.x + grantTypeNodeTransformXY.x
      //     const nodePositionY: number = node.y + grantTypeNodeTransformXY.y
      //     // console.log('(nodePositionX, nodePositionY): ', [nodePositionX, nodePositionY])


      //     // 3. calc vectors (with length representing RCI value) between this node/glyph and all impact entities
      //     let totalForceX = 0;
      //     let totalForceY = 0;

      //     for (let j = 0; j < entityPositions.length; j++) {
      //       const entityPos = entityPositions[j];
      //       const impactEntity = entityPos.entity;

      //       // get RCI value
      //       let RCIValue = 0
      //       if (impactTypeRefined === 'direct_impact') {
      //         RCIValue = node[`RCI_num_${impactEntity}`] || 0
      //       } else if (impactTypeRefined === 'indirect_impact') {
      //         RCIValue = node[`RCI_num_citing_${impactEntity}`] || 0
      //       }

      //       // 直接累加force，避免创建中间数组
      //       const forceMultiplier = (RCIValue - 1) * forceStrength;
      //       totalForceX += (entityPos.x - nodePositionX) * forceMultiplier;
      //       totalForceY += (entityPos.y - nodePositionY) * forceMultiplier;
      //     }

      //     // Move the node towards the target
      //     node.vx += totalForceX;
      //     node.vy += totalForceY;
      //     node.x += node.vx;
      //     node.y += node.vy;
      //   }
      // }

      // force 2: Containment Force
      // opt 1: Containment Force —— 用力回拉，别硬裁剪
      const forceContain = (cool: number) => {
        const kcBase = 0.06;            // 回拉基准
        const kc = cool * kcBase * WB;      // ★ 乘上 β
        // const kc = alpha * kcBase;      // 随 alpha 冷却
        const EDGE_PAD = 4;             // 圆边界留白（像素）
        const EPS = 1e-6;

        for (const node of circleData) {
          const nodeRadius = glyph_SizeScale(node[glyphSizeScaleAttr]) * glyphParameterDict.glyphR;
          const dx = node.x - 0;  // centerX=0
          const dy = node.y - 0;  // centerY=0
          const d  = Math.hypot(dx, dy) || EPS;

          const dmax = maxRadius - (nodeRadius + EDGE_PAD);
          if (d > dmax) {
            const over = d - dmax;      // 超出量
            const ux = dx / d, uy = dy / d;

            // 非线性回拉：越靠近边界越强
            // 线性 over 往往不够，这里加一个 (1 + over/dmax) 项
            let mag = kc * over * (1 + over / (dmax * 0.25));  // 0.25 可调（越小越硬）

            // 限幅，避免瞬时尖峰
            const MAG_MAX = 5 * WB;         // ★ 限幅按 β 缩放（可选）
            // const MAG_MAX = 5;
            if (mag > MAG_MAX) mag = MAG_MAX;

            node.vx += -mag * ux;
            node.vy += -mag * uy;

            // 轻柔的半硬夹紧（可选）：避免同一 tick 中被其它力继续推外
            const s = dmax / d;
            if (s < 1) {
              // 只做一点点回缩，别一步到位：更平滑
              const soft = Math.max(s, 0.98);   // 0.98~1 的范围
              node.x *= soft;
              node.y *= soft;
            }
          }
        }
      };
      // // opt 2: vis2024 version
      // const forceContain = () => {
      //   for (let node of circleData) {
      //     const nodeRadius = glyph_SizeScale(node[glyphSizeScaleAttr]) * glyphParameterDict.glyphR
      //     const dx = node.x - centerX;
      //     const dy = node.y - centerY;
      //     const distance = Math.sqrt(dx * dx + dy * dy);
      //     const maxDistance = maxRadius - nodeRadius;
      //     if (distance > maxDistance) {
      //       const scaleFactor = maxDistance / distance;
      //       node.x *= scaleFactor;
      //       node.y *= scaleFactor;
      //       // console.log('scaleFactor: ', scaleFactor, maxDistance, distance)
      //       // node.x *= scaleFactor * 0.5;
      //       // node.y *= scaleFactor * 0.5;
      //     }
      //   }
      // }

      // force 3: Collsion Force
      const collideStrengthBase = glyphStyle.collideStrength ?? 0.7;
      const collideStrength = Math.max(0, Math.min(1, collideStrengthBase * WG)); // ★ 乘上 γ
      const collide = d3.forceCollide()
        .strength(collideStrength)
        // .strength(glyphStyle.collideStrength)
        .radius((d: any) => glyph_SizeScale(d[glyphSizeScaleAttr]) * glyphParameterDict.glyphR + nodePadding)
        .iterations(1)
        // .strength(0.5)

      const simulation = forceSimulation(circleData)
        .force('attributeForce', attributeForce)
        .force('contain', forceContain)
        .force('collide', collide)
        .alphaDecay(0.1); // Adjust this value to control the number of "ticks". By default, the alpha decay rate is set to 0.0228, which usually results in about 300 "ticks"


      // 添加throttling变量来控制tick更新频率
      let tickCount = 0;
      const updateFrequency = 3; // 每3个tick更新一次UI，减少渲染压力

      // 三种力 (attributeForce, forceContain, collide) 本身只定义方向和强度；
      // 而 alpha cooling / velocity decay 是在这里统一调度它们的更新。
      simulation
        .alpha(0.5)  // 恢复合理的初始alpha值
        .alphaDecay(0.08)  // 适中的decay速度
        .velocityDecay(0.3)  // 添加速度衰减，让动画更稳定
        .on('tick', () => {
          // 使用throttling减少UI更新频率
          tickCount++;
          if (tickCount % updateFrequency === 0) {
            setCircleData([...simulation.nodes()]);
          }
        })
        .on('end', () => {
          // 1. update circle position
          const updatedCircleData = [...simulation.nodes()]
          // console.log('updatedCircleData: ', updatedCircleData)
          setCircleData(updatedCircleData);

          // note: 2 & 3位置不能互换。只有先把grant node position更新了，才能更新setIsDrawGrantTypeNodeFinished。不然mainview里面依旧接受不到grant node position
          // alternative: 2&3搞一个参数
          // 2. send the final node position to state, for mainview (fetch grant node position) next step layout
            // (1) layout impact nodes & rotate entity type circle packing to minimize edge crossing + draw edge by using this node position
            // (2) add edge links
          const updatedGrantNodePositionList: MainViewTypes.GrantNodePosition[] = updatedCircleData.map(d => {
            return {
              grant_field_code: d.grant_field_code,
              // grant_field_name: d.grant_field_name,
              x: d.x,
              y: d.y,
              radius: glyph_SizeScale(d[glyphSizeScaleAttr])
            }

          })
          updateGrantFieldNodePosition({
            grantNodePositionList: updatedGrantNodePositionList,
            isDrawGrantTypeNodeFinished: true,
          })

          // to update circle opacity
          // setIsDrawGrantTypeNodeFinished(true);

          // ui reducer
          setShowEntityFieldLevelGraph(true)
          setShowEntityTypeLevelGraph(false)
          if (citationFlowType === CitationFlowType.HISTORICAL) {
            isShowHistoricalFlow(true)
            isShowPredictionFlow(false)
          } else if (citationFlowType === CitationFlowType.PREDICTION) {
            isShowHistoricalFlow(false)
            isShowPredictionFlow(true)
          }

          // console.log('simulation end (grant glyph)')
        })
    }

    // return () => simulation.stop();
  },
    [
      // circleData,
      // glyphParameterDict.glyphR,
      // glyph_SizeScale,
      impactStatisticsTypeList,
      // isEntityTypeGraphFinished,
      // maxRadius,
      // nodePadding,
      // updateGrantFieldNodePosition,
      // updatedEntityFieldData,

      // glyphDataAll,
      // entityFieldGraphData,
      // predictionData,
      // isEntityTypeGraphFinished,
      // impactStatisticsTypeList,

        // glyphType, glyphDataAll, topKNodes

      updatedEntityFieldDataRaw,
      // updatedEntityFieldData, grantTypeNodeData,
    ]
  );



  return (
    <g id='g-grant-type-node' transform={`translate(${grantTypeNodeX}, ${grantTypeNodeY})`}>
      {/* 辅助圆: grant type node, with a fixed node size */}
      {/* note: have been moved to EntityTypeLevelGraph */}
      {/* <circle className='background-circle'
              cx={0} cy={0} r={grantGlyphGroupR + 2} fill='none'
              // stroke={ showEntityTypeLevelGraph ? 'white' : 'none' }
              stroke='lightgrey'
              strokeWidth={1.5} strokeDasharray={"5 8"} strokeOpacity={0.5}
      /> */}
      {/* <circle className='background-circle'
              cx={0} cy={0} r={grantGlyphGroupR}
              fill={ showEntityTypeLevelGraph ? 'white' : 'none' }
              stroke={ showEntityTypeLevelGraph ? 'lightgrey' : 'none' }
              // stroke='lightgrey'
              strokeWidth={2} strokeDasharray={8} strokeOpacity={0.5}
      /> */}

      { isEntityTypeGraphFinished && <GlyphGroup
                                        glyphData={glyphData}
                                        entityFieldGraphData={entityFieldGraphData} // for filter topK grant field nodes, based on impactType
                                        predictionData={predictionData} // to show prediction result

                                        circleData={circleData}
                                      />
      }
    </g>
  )
}

export default GrantTypeNode;